module.exports = __webpack_public_path__ + "img/15-4.e6d1cd56.png";